<template>
  <div class="home">
    <div class="inner">
      <h1>1</h1>
      <h1 style="color: #ff323f">1</h1>
      <h1>:1</h1>
      <h1 style="color: #ff323f">1</h1>
      <h1 style="display: block">COUNTER APP</h1>
    </div>
    <div class="below">
      <div class="left">
        <h3>ABOUT PRODUCT</h3>
        <p>
          THIS IS AN APP THAT LETS YOU SET, RESET, INCREMENT, AND DECREMENT A
          COUNTER VALUE
        </p>
      </div>
      <div class="right">
        <h2>20+</h2>
        <p>USERS. TESTED AND TRUSTED.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '@/assets/styles/homepage.css'
</style>
